import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaffRolePipe } from './pipes/staff-role.pipe';
import { RoleCheckPipe } from './pipes/role-check.pipe';
import { PermissionPipe } from './pipes/permission.pipe';
import { RolePipe } from './pipes/role.pipe';

@NgModule({
  declarations: [StaffRolePipe, RoleCheckPipe, PermissionPipe, RolePipe],
  imports: [CommonModule],
  exports: [StaffRolePipe, RoleCheckPipe, PermissionPipe, RolePipe]
})
export class RoleModule {}
